import {
  setFields,
  setLogic,
  setCriteria
} from 'components/page/FilterCriteria__REFACTORED/flow/actions';
import { get } from 'store/http/httpAction';
import { setModalSoters } from 'views/ReportTableSetup/flow/actions';
import { SET_AVAILABLE_COLUMNS, SET_ZONES, RESET_SELECTEDCOLS } from './actionTypes';
import { setName, setFormat } from 'views/ReportFilters/flow/actions';
import { checkRestriction } from '../utils/index';

export const setAvailableColumns = availableColumns => ({
  type: SET_AVAILABLE_COLUMNS,
  payload: { availableColumns }
});

export const resetSelectedCols = () => ({
  type: RESET_SELECTEDCOLS,
});

export const setZones = zonesData => ({
  type: SET_ZONES,
  payload: { zonesData }
});

export const tryFetchReportSettingsById = id => (dispatch, getState) =>
  get(`/admin/report/${id}`, {}, dispatch).then(data => {
    const store = getState();
    if (!_.isEmpty(data.data)) {
      const { name, format, setup_properties } = data.data;
      dispatch(setName(name));
      dispatch(setFormat(format));

      const { condition_logic, filters, ...columnSettings } = setup_properties;
      // set filters
      dispatch(setCriteria(checkRestriction(filters, store)));
      dispatch(setLogic(condition_logic ? condition_logic : ''));
      // set columns
      dispatch(setZones(columnSettings));
      if (_.isArray(setup_properties.table_order_by) &&
          _.isArray(setup_properties.in_group_order_by) &&
          !_.isEmpty(setup_properties.table_order_by) &&
          !_.isEmpty(setup_properties.in_group_order_by)
      ) {
        dispatch(setModalSoters(setup_properties.table_order_by, setup_properties.in_group_order_by));
      }
    }
  });

export const tryFetchColumns = (objectType, reportId) => dispatch =>
  get(`/admin/metadata/object/${objectType}`, {}, dispatch).then(data => {
    const main =
      data && data.main && _.isArray(data.main.data) ? data.main.data : [];
    const cstm =
      data && data.cstm && _.isArray(data.cstm.data) ? data.cstm.data : [];
    const columns = [...main, ...cstm];
    dispatch(setAvailableColumns(columns));
    dispatch(setFields(columns));

    if (reportId !== 'new') {
      dispatch(tryFetchReportSettingsById(reportId));
    }
  });



// WEBPACK FOOTER //
// ./src/views/ReportSetup/flow/actions.js